var render = function render(){var _vm=this,_c=_vm._self._c;return _c('custom-select',{class:{ 'enter-child-ages': _vm.getSelectedRoomDetails.length },attrs:{"placeholder":"Enter Children’s Ages","options":_vm.ageOptions},model:{value:(_vm.ageChild),callback:function ($$v) {_vm.ageChild=$$v},expression:"ageChild"}})
}
var staticRenderFns = []

export { render, staticRenderFns }